import { decompressRoles } from '../../utils/user/checkIsAdminAllowedByToken/checkIsPublisherUser';
import { LaunchDarklyUserInfo } from './buildLaunchDarklyContext';

type RoleAssignment = {
  'entity-id'?: string;
  role?: {
    name?: string;
  };
};

const parseRoleAssignments = (userInfo: LaunchDarklyUserInfo): RoleAssignment[] => {
  if (!userInfo.user_role_v4) {
    return [];
  }

  try {
    if (userInfo.compression) {
      return decompressRoles(userInfo.user_role_v4);
    }

    return JSON.parse(userInfo.user_role_v4) as RoleAssignment[];
  } catch {
    try {
      return decompressRoles(userInfo.user_role_v4);
    } catch {
      return [];
    }
  }
};

export const getOrganizationRoleNamesFromToken = (userInfo: LaunchDarklyUserInfo, organizationId: string): string[] => {
  return parseRoleAssignments(userInfo)
    .filter((assignment) => assignment['entity-id'] === organizationId)
    .map((assignment) => assignment.role?.name)
    .filter((roleName): roleName is string => Boolean(roleName));
};
